import { Booking } from "../../models/booking";
import { Port } from "../../models/port";
import { BookingStatus } from "../../util/enums";

export const isBookingUnavaliableToUnderReview = (booking?: Booking) => {
  if (!booking || !booking.statusShipment) return true;

  return [BookingStatus.CANCELLED, BookingStatus.UNDER_REVIEW, BookingStatus.RECEIVED].includes(
    booking.statusShipment as BookingStatus
  );
};

export const isBookingUnavaliableToAction = (booking?: Booking) => {
  if (!booking || !booking.statusShipment) return true;

  return [BookingStatus.CANCELLED, BookingStatus.RECEIVED].includes(
    booking.statusShipment as BookingStatus
  );
};

export const isBookingCancelled = (booking?: Booking) => {
  if (!booking || !booking.statusShipment) return true;

  return BookingStatus.CANCELLED === booking.statusShipment;
};

export const isBookingInCFSProcess = (booking?: Booking) => {
  if (!booking || !booking.statusShipment) return false;

  return [BookingStatus.CFS_RECEIVED, BookingStatus.CFS_REVIEW, BookingStatus.CONFIRMED].includes(
    booking.statusShipment as BookingStatus
  );
};

export const formatPortInputValue = (port?: Port) => {
  if (!port) return "";

  const { country, locationName, siteCode } = port;
  const countryName = country?.name;

  if (!locationName && !countryName) return siteCode || "";

  const parts = [
    locationName,
    countryName,
    siteCode && `(${siteCode})`,
  ].filter(Boolean);

  return parts.join(", ").replace(", (", " (");
};

export enum BookingTabs {
  DETAILS = "details",
  ORDERS = "orders",
  SSCC = "sscc",
  DOCUMENTS = "documents",
  MARK_AND_NUMBERS = "markAndNumbers",
  COMMERCIAL_INVOICE = "commercialInvoice",
  VOLUME_AND_WEIGHT = "volumeAndWeight",
  SUMMARY = "summary",
  TRACKING = "tracking",
}

export enum DespatchesTabs {
  DETAILS = "details",
  PRODUCTS = "products",
  SHIPPING_ITEMS = "shipping_items",
  TRUCK = "truck",
}

export enum BookingObjects {
  BOOKING = "booking",
  CONTAINERS = "containers",
  MILESTONES = "milestones",
  PURCHASE_ORDERS = "purchaseOrders",
  CARTONS = "cartons",
  DOCUMENTS = "documents",
  MARK_AND_NUMBERS = "markAndNumbers",
  COMMERCIAL_INVOICE = "commercialInvoice",
}

export interface BookingChangeKeys {
  [BookingObjects.BOOKING]: boolean;
  [BookingObjects.CONTAINERS]?: boolean;
  [BookingObjects.MILESTONES]?: boolean;
  [BookingObjects.PURCHASE_ORDERS]?: boolean;
  [BookingObjects.CARTONS]?: boolean;
  [BookingObjects.DOCUMENTS]?: boolean;
  [BookingObjects.MARK_AND_NUMBERS]?: boolean;
  [BookingObjects.COMMERCIAL_INVOICE]?: boolean;
}

export type BookingChangeOptions = BookingObjects;

export enum ShipmentObjects {
  SHIPMENT = "shipment",
  CONTAINERS = "containers",
  MILESTONES = "milestones",
  PURCHASE_ORDERS = "purchaseOrders",
  CARTONS = "cartons",
  DOCUMENTS = "documents",
}

export interface ShipmentChangeKeys {
  [ShipmentObjects.SHIPMENT]: boolean;
  [ShipmentObjects.CONTAINERS]?: boolean;
  [ShipmentObjects.MILESTONES]?: boolean;
  [ShipmentObjects.PURCHASE_ORDERS]?: boolean;
  [ShipmentObjects.CARTONS]?: boolean;
  [ShipmentObjects.DOCUMENTS]?: boolean;
}

export type ShipmentChangeOptions = ShipmentObjects;
